import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ResetPasswordRequest,
  login,
  me,
  LoginRequest,
  signUp,
  SignUpRequest,
  resetPassword,
  verifySecurityCode,
  SecurityCodePayload,
  NewPasswordData,
  setNewPassword,
  UpdateMeRequest,
  updateMe,
  changePassword,
  ChangePasswordData,
  ResendVerificationRequest,
  resendVerificationEmail,
} from '@app/api/auth.api';
import { setUser } from '@app/store/slices/userSlice';
import { deleteToken, deleteUser, persistToken, persistUser, readToken } from '@app/services/localStorage.service';

export interface AuthSlice {
  token: string | null;
}

const initialState: AuthSlice = {
  token: readToken(),
};

export const doLogin = createAsyncThunk('auth/admin/login', async (loginPayload: LoginRequest, { dispatch }) =>
  login(loginPayload).then((res) => {
    dispatch(setUser(res.user));
    persistUser(res.user);
    persistToken(res.token);

    return res.token;
  }),
);

export const getMe = createAsyncThunk('auth/me', async (undefined, { dispatch }) =>
  me().then((res) => {
    dispatch(setUser(res.user));
    persistToken(res.token);

    return res.token;
  }),
);

export const doSignUp = createAsyncThunk('auth/doSignUp', async (signUpPayload: SignUpRequest) =>
  signUp(signUpPayload),
);

export const doResetPassword = createAsyncThunk(
  'auth/doResetPassword',
  async (resetPassPayload: ResetPasswordRequest) => resetPassword(resetPassPayload),
);

export const doVerifySecurityCode = createAsyncThunk(
  'auth/doVerifySecurityCode',
  async (securityCodePayload: SecurityCodePayload) => verifySecurityCode(securityCodePayload),
);

export const doSetNewPassword = createAsyncThunk('auth/doSetNewPassword', async (newPasswordData: NewPasswordData) =>
  setNewPassword(newPasswordData),
);

export const doChangePassword = createAsyncThunk('auth/doChangePassword', async (data: ChangePasswordData) =>
  changePassword(data),
);

export const doUpdateMe = createAsyncThunk('auth/doUpdateMe', async (data: UpdateMeRequest, { dispatch }) =>
  updateMe(data).then((res) => {
    dispatch(setUser(res));

    return res;
  }),
);

export const doLogout = createAsyncThunk('auth/doLogout', (payload, { dispatch }) => {
  deleteToken();
  deleteUser();
  dispatch(setUser(null));
});

export const doResendVerificationEmail = createAsyncThunk(
  'auth/doResendVerificationEmail',
  async (data: ResendVerificationRequest) => resendVerificationEmail(data),
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doLogin.fulfilled, (state, action) => {
      state.token = action.payload;
    });
    builder.addCase(doLogout.fulfilled, (state) => {
      state.token = null;
    });
    builder.addCase(doUpdateMe.fulfilled, (state) => {
      // state.token = '';
    });
  },
});

export default authSlice.reducer;
